import { useState, useEffect, useMemo } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

/**
 * Hook to fetch and check the current user's effective permissions.
 * Returns { permissions, hasPermission, hasAny, loading }
 */
export function usePermissions(token) {
  const [permissions, setPermissions] = useState(new Set());
  const [loading, setLoading] = useState(true);
  const headers = useMemo(() => ({ Authorization: `Bearer ${token}` }), [token]);

  useEffect(() => {
    if (!token) { setLoading(false); return; }
    let cancelled = false;
    axios.get(`${BACKEND_URL}/api/my-permissions`, { headers })
      .then(res => {
        if (!cancelled) setPermissions(new Set(res.data.permissions || []));
      })
      .catch(() => {})
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [token, headers]);

  const hasPermission = (permId) => permissions.has(permId);
  const hasAny = (...permIds) => permIds.some(p => permissions.has(p));

  return { permissions, hasPermission, hasAny, loading };
}
